<template>
	<div id="d21-confirmation">
		<div class="d21-block">
			<div class="mdl-grid" v-if="Registration">
				<label class="text-header" v-if="Channel.Type === 'ContactTrackingWithCode'">
					<i class="material-icons">check_circle</i>{{ T("user_approved_success") }}
				</label>
				<label class="text-header" v-else>
					<i class="material-icons">check_circle</i>{{ T("confirmation_thanks") }}
				</label>
				<div class="mdl-cell mdl-cell--12-col d-flex space-between">
					<br />
					{{ T("Email_Confirmation_Note_start") + " " + Registration.Persons[0].Communication.Email + " " + T("Email_Confirmation_Note_end") }}<br />
					<template v-if="Channel.Type !== 'ContactTrackingWithCode'">
						{{ T("OneTicketing_Please_Checkout") }}
					</template>
				</div>
				<div class="d21-text" v-if="Channel.Content && Channel.Content.CheckOutCoronaHint" v-html="Channel.Content.CheckOutCoronaHint">
				</div>
			</div>
			<div class="mdl-grid" v-else-if="Channel.Mode === 'TimeSlots'">
				<label class="text-header">
					<i class="material-icons">sentiment_satisfied_alt</i>{{ T("OneTicketing_AppointmentArrangement") }}
				</label>
				<div class="mdl-cell mdl-cell--12-col d-flex space-between">
					{{ T("Email_Confirmation_Note_start") + " " + Reservation.ProfileInfos.Shipping.Communication.Email + " " + T("Email_Confirmation_Note_end") }}
				</div>
			</div>
			<div class="mdl-grid" v-else>
				<label class="text-header">
					<i class="material-icons">sentiment_satisfied_alt</i>{{ T("OneTicketing_thanks_for_booking") }}
				</label>
				<div class="mdl-cell mdl-cell--12-col d-flex space-between">
					{{ T("Email_Confirmation_Note_AccessCode_start") + " " + Reservation.ProfileInfos.Shipping.Communication.Email + " " + T("Email_Confirmation_Note_end") }}
				</div>
			</div>
			<div class="mdl-grid" v-if="Channel.Type === 'ContactTrackingWithCode'">
				<div class="mdl-cell mdl-cell--12-col d21-qrcode">
					{{ T("AccessCode") + ":" }}<br />
					<img :src="'https://cdn.dirs21.de/v1/cdn/images/ticketing/' + Channel._oid + '/' + Registration._uuid + '.png'" width="700" style="border: 0px; max-width: 300px; max-height: 300px;" />
				</div>
			</div>
			<div class="mdl-grid">
				<div class="mdl-cell">
					<router-link :to="{ name: 'query' }" class="btn btn-primary"><span>{{ T("confirmation_book_again") }}</span></router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import baseMixin from "../mixins/base";

	export default {
		name: 'd21-confirmation',
		mixins: [baseMixin]
	}
</script>